import { initials } from '@/lib/format';
import { cn } from '@/lib/utils';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

/** Foto do perfil, com as iniciais enquanto carrega ou quando não há foto. */
export function UserAvatar({ name, url, className, ...props }: { name: string; url?: string | null; className?: string; 'aria-hidden'?: boolean }) {
  return (
    <Avatar className={className} {...props}>
      {url && <AvatarImage src={url} alt={props['aria-hidden'] ? '' : `Foto de ${name}`} />}
      <AvatarFallback className={cn(className?.includes('size-1') || className?.includes('size-2') ? 'text-base' : undefined)}>{initials(name)}</AvatarFallback>
    </Avatar>
  );
}
